import styled from 'styled-components/macro'

const InputLabel = styled.label`
  color: var(--color-gray-90);
  display: block;
  margin-bottom: var(--size-spacing-02);
`

export default InputLabel
